"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetQueryRunRpcResponseImplementation = exports.GetQueryRunRpcRequestImplementation = void 0;
const core_1 = require("./core");
class GetQueryRunRpcRequestImplementation extends core_1.BaseRpcRequest {
    constructor() {
        super(...arguments);
        this.method = "getQueryRun";
    }
}
exports.GetQueryRunRpcRequestImplementation = GetQueryRunRpcRequestImplementation;
class GetQueryRunRpcResponseImplementation extends core_1.BaseRpcResponse {
}
exports.GetQueryRunRpcResponseImplementation = GetQueryRunRpcResponseImplementation;
//# sourceMappingURL=get-query-run.type.js.map